export default __webpack_public_path__ + "static/media/cube.a1bc67ed.png";